import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { Row, Col } from 'react-bootstrap';
import ErrorHandler from '../Reusable/ErrorHandler';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class ModalForUpdateKjsMunicipality extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      place: props.kjsWithMunicipality?.municipality?.place,
      municipality: props.kjsWithMunicipality?.municipality,
      institutionType: null,
      kjs: props.kjsWithMunicipality?.kjs,
      kjsMunicipalityList: [],
      pib: '',
      uniqueKjsNumber: '',

      errors: {},
    };
  }

  componentDidMount() {
    const {
      kjsWithMunicipality,
      findAllKjs,
      findAllMunicipalityByPlace,
      findAllPlace,
    } = this.props || {};
    findAllPlace();
    kjsWithMunicipality &&
      findAllMunicipalityByPlace(kjsWithMunicipality?.municipality?.place?.id);
    findAllKjs();
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onKjfFilterChange = (e) => {
    clearTimeout(this.typingTimeout);

    this.typingTimeout = setTimeout(this.handleFilterKJSList, 1800);

    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    const { kjs, municipality } = this.state || {};

    if (!kjs) {
      errors['kjs'] = this.props.t.Errors.kjs;
      hasError = true;
    }
    if (!municipality) {
      errors['municipality'] = this.props.t.Errors.municipality;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const { kjs, municipality } = this.state || {};

    const kjsWithMunicipalityForUpdate = {
      ...this.props.kjsWithMunicipality,
      kjs,
      municipality,
    };

    this.props.updateKjsMunicipality(kjsWithMunicipalityForUpdate);
  };

  handleFilterKJSList = async (newInstitutionType, resetSignal) => {
    let filterCriteriaData = this.setFilterCriteria(
      newInstitutionType,
      resetSignal
    );
    filterCriteriaData.length > 0
      ? await this.props.findAllKjsFilterPageable(
          0,
          100000,
          {
            tableName: 'kjs',
            filterCriteria: filterCriteriaData,
          },
          () => this.handleClose
        )
      : this.props.findAllKjs();
  };

  setFilterCriteria = (newInstitutionType, resetSignal) => {
    const { pib, uniqueKjsNumber, institutionType } = this.state || {};
    let filterCriteriaData = [];
    if (pib)
      filterCriteriaData.push({
        columnName: 'pib',
        columnValue: pib,
      });
    if (uniqueKjsNumber)
      filterCriteriaData.push({
        columnName: 'uniqueNumber',
        columnValue: uniqueKjsNumber,
      });
    if (!resetSignal && (institutionType || newInstitutionType))
      filterCriteriaData.push({
        columnName: 'institutionType.id',
        columnValue: newInstitutionType
          ? newInstitutionType.id
          : institutionType.id,
      });
    return filterCriteriaData;
  };

  changeComboAutocomplete = (name, newValue) => {
    switch (name) {
      case 'place':
        if (!newValue) {
          this.props.clearMunicipalityList();
        } else {
          this.props.findAllMunicipalityByPlace(newValue.id);
        }
        this.setState({
          place: newValue,
          municipality: null,
        });
        break;
      case 'municipality':
        if (!newValue) {
        } else {
          this.props.kjsList.length === 0 && this.props.findAllKjs();
        }
        this.setState({
          municipality: newValue,
        });
        break;
      case 'kjs':
        this.setState({
          kjs: newValue,
        });
        break;
      default:
        this.setState({ [name]: newValue });
    }
  };

  render() {
    const { error, deleteError, t } = this.props || {},
      { Placeholders, Labels } = t || {};

    const { kjs, municipality, place, pib, uniqueKjsNumber, errors } =
      this.state || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <Row className={`mb-4 mt-5`}>
                <Col md={6}>
                  <ComboBoxAutocomplete
                    data={this.props.placeList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('place', newValue)
                    }
                    text={(a) => a.name}
                    placeholder={Placeholders.place}
                    wholeObject
                    updateValue={place}
                  />
                </Col>
                <Col md={6}>
                  <ComboBoxAutocomplete
                    data={this.props.municipalityList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('municipality', newValue)
                    }
                    placeholder={Placeholders.municipality}
                    text={(a) => a.name}
                    wholeObject
                    updateValue={municipality}
                    error={errors?.municipality}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md={6}>
                  <InputField
                    name="pib"
                    placeholder={Placeholders.pib}
                    onChange={this.onKjfFilterChange}
                    value={pib}
                    autoComplete="off"
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    name="uniqueKjsNumber"
                    placeholder={Placeholders.uniqueKjsNumber}
                    onChange={this.onKjfFilterChange}
                    value={uniqueKjsNumber}
                    autoComplete="off"
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md={12}>
                  <ComboBoxAutocomplete
                    data={this.props.kjsList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('kjs', newValue)
                    }
                    placeholder={Placeholders.kjs}
                    text={(a) => a.name}
                    wholeObject={true}
                    updateValue={kjs}
                    error={errors?.kjs}
                  />
                </Col>
              </Row>
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForUpdateKjsMunicipality,
  'ModalForUpdateKjsMunicipality'
);
